<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <!-- <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a> -->
        <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.extraTitle || $t('page.'+ (item.meta.permission || item.name)) }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.extraTitle || $t('page.'+ (item.meta.permission || item.name)) }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: []
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      // 用户详情
      if (first.name == "UserDetail") {
        matched = [
          { path: '/', name: 'Home', meta: { title: 'Home' }}, 
          { path: '/user', meta: { permission: "user" }}, 
          { path: '/user/userManageList', name: "UserManageList", meta: { permission: "app:user:manage" }}
        ].concat(matched)
      } 
      else if (first.name == "MerchantProductDetail") {
        matched = [
          { path: '/', name: 'Home', meta: { title: 'Home' }}, 
          { path: '/loanMarket', meta: { permission: "loanMarket" }}, 
          { path: '/merchant/MerchantProductList', name: "MerchantProductList", meta: { permission: "loanMarket:merchantProductList" }}
        ].concat(matched)
      } 
      else if (!this.isDashboard(first)) {
        matched = [{ path: '/', name: 'Home', meta: { title: 'Home' }}].concat(matched)
      }
      this.levelList = matched.filter(item => item.meta && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase() || name.trim().toLocaleLowerCase() === 'home'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path, name } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }

      if (name) {
        this.$router.push(path)
      }
      // this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
